import { Comparator }	from "ts-base/comparator";

import { Textual }		from "@v3/data/textual";

// YYYY-MM-DD
export type IsoDate		= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"IsoDate",
		// TODO time allows day 29-31 in too many months
		/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
		"must be an iso-8601 date in YYYY-MM-DD format"
	);

namespace Extension {
	export const compare	= Comparator.builtinOf<IsoDate>();
};

export const IsoDate	= { ...Extension, ...Base };
